import * as withDashboardActions from "../actions/dashboard-actions";
import { Widget } from "../models/widget"
import { createEntityAdapter } from "@ngrx/entity"
import { createFeatureSelector, createSelector } from "@ngrx/store"
import { DashboardItem } from "../models/dashboard-item"
import { HttpErrorResponse } from '@angular/common/http'
import { EntityState } from "@ngrx/entity"
import { Direction } from "../../common/enums/direction"



export const dashboardItemAdapter = createEntityAdapter<DashboardItem>();

export interface DashboardState extends EntityState<DashboardItem> {
  loading: boolean;
  error: HttpErrorResponse;
  maximisedWidget: Widget;
  scrollDirection: Direction;
};

const INITIAL_STATE: DashboardState = dashboardItemAdapter.getInitialState({
  loading: false,
  error: null,
  maximisedWidget: undefined,
  scrollDirection: undefined
});



export function dashboardReducer(
  state: DashboardState = INITIAL_STATE,
  action: withDashboardActions.Actions
): DashboardState {
  switch (action.type) {
    case withDashboardActions.LOAD:
      return {
        ...state,
        loading: true
      };

    case withDashboardActions.LOAD_COMPLETE:
      {
        return dashboardItemAdapter.setAll(action.payload, { ...state, loading: false });
      }

    case withDashboardActions.LOAD_ERROR:
      {
        return { ...state, loading: false, error: action.payload };
      }

    case withDashboardActions.MAXIMISE:
      {
        return {
          ...state,
          maximisedWidget: action.payload,
        };
      }
    case withDashboardActions.DELETE_ITEM:
    case withDashboardActions.RESTORE:
      {
        return {
          ...state,
          maximisedWidget: undefined,
        };
      }
    case withDashboardActions.CLEAR:
      {
        return INITIAL_STATE;
      };
    case withDashboardActions.SCROLL_UP:
    {
      return {
        ...state,
        scrollDirection: Direction.Up,
      };
      }
    case withDashboardActions.SCROLL_DOWN:
    {
      return {
        ...state,
        scrollDirection: Direction.Down,
      };
    }
    default:
      return state;
  }
};

export const selectDashboardItemsState = createFeatureSelector<DashboardState>('dashboard');


export const {
  selectIds,
  selectEntities,
  selectAll: selectAllDashboardItems,
  selectTotal,
} = dashboardItemAdapter.getSelectors(selectDashboardItemsState);

export const selectById = (id) => createSelector(selectEntities, (entities) => {
  return entities[id] || null;
});
